import axios from 'axios';
import Config from '../../utils/config/config';
import { getSessinIdFromLS, isUserOnline } from '../storage/LocalStorage';

const gRPCURL = Config.gRPCURL
const xApiKey = Config.xApiKey
let sessionId = getSessinIdFromLS();

export const setSessionIdInAxios = (newSessionId) => {
  sessionId = newSessionId;
  axiosInstance.defaults.headers.sessionId = newSessionId;
};

const axiosInstance = axios.create({
  baseURL: gRPCURL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
    "x-api-key": xApiKey,
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {

    // small retry if sessionId is not ready yet
    if (!sessionId) {
      await new Promise((res) => setTimeout(res, 90));
      sessionId = getSessinIdFromLS();
    }

    if (sessionId) {
      config.headers.sessionId = sessionId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);


axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const { status } = error.response;
      if (status === 401 || status === 500) {
        localStorage.removeItem('sessionId');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

const checkOnline = () => {
  if (!isUserOnline()) {
    const err = new Error("User is offline");
    console.error(err.message);
    return Promise.reject(err);
  }
  return Promise.resolve();
};


const Api = {
  get: (url, config = {}) => checkOnline().then(() => axiosInstance.get(url, config)),
  post: (url, data, config = {}) => checkOnline().then(() => axiosInstance.post(url, data, config)),
  put: (url, data, config = {}) => checkOnline().then(() => axiosInstance.put(url, data, config)),
  patch: (url, data, config = {}) => checkOnline().then(() => axiosInstance.patch(url, data, config)),
};

export default Api;
